import { IEntityDto } from "./base";

export interface IPartnerResourceContext extends IEntityDto {
  apikey?: string;
  alias?: string;
  bearerDescription?: string;
  bearerId?: number;
  city?: string;
  countryDisplayName?: string;
  countryName?: string;
  defaultWarehouseDescription?: string;
  defaultWarehouseId?: number;
  departmentDescription?: string;
  departmentId?: number;
  emailIdentifier?: string;
  endEmployment?: number;
  invitedById?: number;
  invitedByName?: string;
  ledgerDescription?: string;
  ledgerId?: number;
  mayBookkeepFinance?: boolean;
  name?: string;
  partnerId?: number;
  placeName?: string;
  purposeDescription?: string;
  purposeId?: number;
  senderEmail?: string;
  showInFinance?: boolean;
  showInOrder?: boolean;
  showInScheduling?: boolean;
  smsSender?: string;
  street?: string;
  tags?: string[];
  theme?: string;
  themeFriendly?: string;
  userId?: number;
  workPhone?: string;
  zip?: string;
}
